<template>
  <span class="money">&pound;{{ amount.toFixed(2) }}</span>
</template>

<script>
export default {
  name: "Money",
  props: ["amount"],
}
</script>
